import { EyeShowIcon } from '@rsos/base-assets/icons';
import { Box, Text } from '@rsos/base-components';
import Popover from '@rsos/components/capstone/base/Popover';
import { useFlag } from '@rsos/flags';
import { LayerName } from '../LayerOpacityControl.styles';
import { Wrapper } from './LayerOpacityControl.styles';
import { OpacitySlider } from './OpacitySlider';
import { usePopoverControls } from './usePopoverControls';

export const opacityControlWidth = 200;

interface Props {
  layerId: string;
  layerName?: string;
}

export const LayerOpacityControl = ({ layerId, layerName }: Props) => {
  const { isOpen, open, close } = usePopoverControls(layerId);

  const isEnabled = useFlag('layers-opacity-controls');

  if (!isEnabled) {
    return null;
  }

  return (
    <Box horizontal marginRight="9px">
      <Popover
        trigger={
          <Box
            onClick={open}
            onMouseLeave={close}
            align="center"
            justify="center"
            marginLeft={2}
            cursor="pointer"
          >
            <EyeShowIcon color="secondaryText" width={15} height={15} />
          </Box>
        }
        isOpen={isOpen}
        popoverID="example-popover"
        xOffset={-opacityControlWidth}
        yOffset={20}
      >
        <Wrapper
          width={`${opacityControlWidth}px`}
          onMouseEnter={open}
          onMouseLeave={close}
        >
          <Box marginBottom={1} horizontal>
            <LayerName size="small" color="secondaryText">
              {layerName}
            </LayerName>
            <Text size="small" color="secondaryText">
              opacity
            </Text>
          </Box>
          <OpacitySlider layerId={layerId} />
        </Wrapper>
      </Popover>
    </Box>
  );
};
